const CheckConnectivitiyResultsConstants = {
  documentationLinks: {
    signallingErrorDocumentationLink:
      'https://support.freshcaller.com/support/solutions/articles/229266-network-requirements-and-recommendations#1.-Ports-to-be-whitelisted',
    mediaServerErrorDocumentationLink:
      'https://support.freshcaller.com/support/solutions/articles/229266-network-requirements-and-recommendations#2.-IP-Addresses-to-be-whitelisted',
    badCallQualityDocumentationLink:
      'https://support.freshcaller.com/support/solutions/articles/229266-network-requirements-and-recommendations#Bandwidth-Requirements',
    callQualityImprovement:
      'https://support.freshcaller.com/support/solutions/articles/229266-network-requirements-and-recommendations#Best-Practices-and-Recommendations',
    dnsLookupTestDocumentation:
      'https://support.freshcaller.com/support/solutions/articles/229266-network-requirements-and-recommendations#3.-Domains-to-be-whitelisted',
  },
};

const AppLogo = {
  url: '/assets/logos/logo-fworks-white.svg',
  alt: 'Freshworks logo',
};

export { CheckConnectivitiyResultsConstants, AppLogo };
